import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=8bdf2f5e&"
import script from "./ContractList.vue?vue&type=script&lang=ts&"
export * from "./ContractList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports